import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

function ReportsNoInputModalForm({ close, createReport }) {
  const handleCreate = () => createReport({});

  return (
    <Row className="mt-auto">
      <Col className="d-flex justify-content-center gap-3">
        <Button className="bo-button" onClick={handleCreate}>
          Create
        </Button>
        <Button className="bo-button" onClick={close}>
          Cancel
        </Button>
      </Col>
    </Row>
  );
}

export default ReportsNoInputModalForm;
